/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import FormBlock from 'loracoms/FormBlock';
import ControlTips from 'loracoms/ControlTips';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import deviceActions from 'loraactions/device';
import { isHexString } from 'lorautils/checkers/numbers';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  sendCmd: React.PropTypes.func.isRequired,
  sent: React.PropTypes.object.isRequired,
};

class AddBroadcastReq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: (
        new ErrorSet()
          .add('FE_EMPTY', 'devaddr')
          .add('FE_EMPTY', 'nwkskey')
          .add('FE_EMPTY', 'appskey')
      ),
      appskey: '',
      nwkskey: '',
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.macview');
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { sent } = nextProps;
    this.setState({ sentStatus: sent.status });
  }

  checkAddr(key, val, errors = this.state.errors) {
    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!isHexString(val, { len: 8 })) {
      return errors.add(
        'FE_INVALIDADDR',
        key,
        { message: this.intlMsg.errorMsg('FE_INVALIDADDR') },
      );
    }
    return errors.remove(key);
  }

  handleChangeDevaddr(e) {
    let val = _.trim(e.target.value);
    val = val.replace(/:|-/g, '');
    let { errors } = this.state;
    errors = this.checkAddr('devaddr', val, errors);
    this.setState({ errors, devaddr: val });
  }

  checkKeys(key, val, errors = this.state.errors) {
    if (val.length === 0) {
      return errors.add('FE_EMPTY', key);
    } else if (!isHexString(val, { len: 32 })) {
      return errors.add(
        'FE_INVALIDAPPKEY',
        key,
        { message: this.intlMsg.errorMsg('FE_INVALIDAPPKEY') },
      );
    }
    return errors.remove(key);
  }

  handleChangeKeys(key, e) {
    const val = _.trim(e.target.value);
    let { errors } = this.state;
    errors = this.checkKeys(key, val, errors);
    this.setState({ errors, [key]: val });
  }

  handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    const { errors } = this.state;
    if (!errors.isEmpty()) {
      return;
    }

    const { deviceId, sendCmd } = this.props;
    const { devaddr, nwkskey, appskey } = this.state;
    sendCmd(deviceId, {
      devaddr,
      nwkskey,
      appskey,
    });
  }

  render() {
    const {
      sentStatus = '',
      devaddr = '',
      nwkskey = '',
      appskey = '',
      errors,
      submitted = false,
    } = this.state;

    return (
      <Form horizontal onSubmit={this.handleSubmit}>
        <FormGroup validationState={submitted && errors.has('devaddr') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">
              {this.intlMsg.msg('addbroadcastreq.address')}
            </ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={devaddr}
              placeholder={this.intlMsg.msg('addbroadcastreq.devaddr.placeholder')}
              onChange={e => this.handleChangeDevaddr(e)}
            />
            <ControlTips
              show={submitted && errors.has('devaddr')}
              message={this.intlMsg.errorMsg(errors.get('devaddr'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('appskey') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">
              {this.intlMsg.msg('addbroadcastreq.appskey.label')}
            </ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={appskey}
              placeholder={this.intlMsg.msg('addbroadcastreq.keys.placeholder')}
              onChange={e => this.handleChangeKeys('appskey', e)}
            />
            <ControlTips
              show={submitted && errors.has('appskey')}
              message={this.intlMsg.errorMsg(errors.get('appskey'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('nwkskey') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">
              {this.intlMsg.msg('addbroadcastreq.nwskey.label')}
            </ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={nwkskey}
              placeholder={this.intlMsg.msg('addbroadcastreq.keys.placeholder')}
              onChange={e => this.handleChangeKeys('nwkskey', e)}
            />
            <ControlTips
              show={submitted && errors.has('nwkskey')}
              message={this.intlMsg.errorMsg(errors.get('nwkskey'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <RichButton
              status={sentStatus}
              states={[{
                status: 'default',
                label: this.intlMsg.msg('submit'),
                style: 'primary',
                type: 'submit',
              }, {
                status: 'success',
                label: this.intlMsg.msg('submit.success'),
                style: 'success',
                timer: () => this.setState({ sentStatus: '' }),
              }, {
                status: 'failure',
                label: this.intlMsg.msg('submit.failure'),
                style: 'danger',
                timer: () => this.setState({ sentStatus: '' }),
              }]}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <FormBlock
              show={errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

AddBroadcastReq.propTypes = propTypes;

const mapStateToProps = state => ({
  sent: state.device.sendAddBroadcastReq,
});

const mapDispatchToProps = {
  sendCmd: deviceActions.sendAddBroadcastReq,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AddBroadcastReq));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/coms/AddBroadcastReq.jsx